import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { LabourService } from '@app/services/labour.service';
import { OeeService } from '@app/services/oee.service';

@Component({
  selector: 'tt-select-labour-pu',
  templateUrl: './select-labour-pu.component.html',
  styleUrls: ['./select-labour-pu.component.css'],
  standalone: false
})
export class SelectLabourPuComponent implements OnInit {
    public items: Item[] = [];

    public webpageName = '';

    public selecting = false;

    public error = '';

    public canSelect = () => !this.selecting;

    constructor(
        private labour: LabourService,
        private oee: OeeService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async ngOnInit(): Promise<void> {
        this.webpageName = String(this.navigator?.params['webpagename'] ?? '');

        try { this.items = await this.oee.getRegisteredLabours(this.webpageName); }
        catch (error) { this.showError(error); }
    }

    public async select(item: Item): Promise<void> {
        if (this.selecting || item.item_id === '') return;

        this.selecting = true;
        this.error = '';

        try {
            await this.labour.selectRegisteredLabour(item.item_id, this.webpageName);

            if (this.webpageName === 'oeedata') this.oee.markLabourSelected();

            await this.navigator?.back();
        } catch (error) {
            this.showError(error);
        } finally {
            this.selecting = false;
        }
    }

    private showError(error: unknown): void {
        this.error = error instanceof Error ? error.message : String(error);
    }
}
